import { render } from "./delta-edit-main.vue?vue&type=template&id=2d6c0d3c&scoped=true"
import script from "./delta-edit-main.vue?vue&type=script&lang=js"
export * from "./delta-edit-main.vue?vue&type=script&lang=js"

import "./delta-edit-main.vue?vue&type=style&index=0&id=2d6c0d3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.16_vue@3.5.13_typescript@5.1.6__webpack@5.99.9/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6c0d3c"]])

export default __exports__